import React from 'react';
import './Loading.css';
import logo from '../assets/logo.svg';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="logo-wrapper">
          <img src={logo} alt="KOS Logo" className="loading-logo" />
          <div className="logo-shadow"></div>
        </div>
      </div>
      <div className="color-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
        <div className="orb orb-4"></div>
      </div>
    </div>
  );
};

export default Loading;
